import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class ToursFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Tours",
      name: "tours",
      value,
    });
  }
}

export default ToursFilter;
export { ToursFilter };
